<template>
  <div class="product-report product-report--query-grid">
    <div class="product-report-query">
      <Row
        :gutter="20"
        class="query-conditions"
      >
        <Col
          v-show="queryFieldVisibility.date"
          :span="queryColSpan"
          class="query-item"
        >
          <DatePicker
            v-model="date"
            style="width: 100%"
            @change="handleDatePickerChange"
          />
        </Col>

        <Col
          v-show="queryFieldVisibility.budget_ids"
          :span="queryColSpan"
          class="query-item"
        >
          <Select
            v-model="budget_ids"
            placeholder="请输入聚合名称"
            style="width: 100%;"
            clearable
            multiple
            filterable
            remote
            collapse-tags
            reserve-keyword
            :remote-method="handleSearchAggregations"
          >
            <Option
              v-for="item in aggregationsOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </Select>
        </Col>

        <Col
          v-show="queryFieldVisibility.product_ids"
          :span="queryColSpan"
          class="query-item"
        >
          <Select
            v-model="product_ids"
            placeholder="请输入产品名称"
            style="width: 100%;"
            clearable
            multiple
            filterable
            remote
            collapse-tags
            reserve-keyword
            :remote-method="handleSearchProducts"
          >
            <Option
              v-for="item in productsOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </Select>
        </Col>

        <Col
          v-show="queryFieldVisibility.product_series_ids"
          :span="queryColSpan"
          class="query-item"
        >
          <Select
            v-model="product_series_ids"
            placeholder="请选择产品系"
            style="width: 100%;"
            clearable
            multiple
            filterable
            remote
            reserve-keyword
            collapse-tags
            :remote-method="handleSearchSeries"
          >
            <Option
              v-for="item in productSeriesOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </Select>
        </Col>

        <Col
          :span="queryActionSpan"
          class="query-item query-item--actions"
        >
          <div class="query-buttons">
            <Button
              plain
              type="primary"
              @click="handleReset"
            >
              重置
            </Button>
            <Button
              type="primary"
              @click="handleSearchData"
            >
              查询
            </Button>
            <Button
              v-if="showQueryToggle"
              type="text"
              class="query-toggle"
              @click="toggleQueryExpand"
            >
              {{ queryExpanded ? '收起' : '展开' }}
              <i :class="queryExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" />
            </Button>
          </div>
        </Col>
      </Row>
    </div>

    <div class="product-report-chart">
      <Tabs
        v-model="dimension"
        class="product-report-tabs"
        @tab-click="handleTabsClick"
      >
        <TabPane
          v-for="item in summary"
          :key="item.key"
          :label="item.name"
          :name="item.key"
        />
      </Tabs>

      <div class="product-report-tabs-header">
        <div>
          <span>展示指标：</span>
          <Select
            v-model="field"
            @change="handleFieldSelectChange"
          >
            <Option
              v-for="item in options"
              :key="item.key"
              :label="item.name"
              :value="item.key"
            />
          </Select>
        </div>

        <RadioGroup
          v-model="summaryType"
          @change="handleSummaryTypeChange"
        >
          <RadioButton label="all">汇总显示</RadioButton>
          <RadioButton label="top">TOP20聚合</RadioButton>
        </RadioGroup>
      </div>

      <div v-loading="chartLoading">
        <Chart
          :dataSource="rawChartData"
          :field="field"
          :type="summaryType"
        />
      </div>
    </div>

    <div class="product-report-detail">
      <Title text="详细数据" />
      <div v-loading="tableLoading">
        <CustomTable
          class="product-report-detail-table"
          topic="ka_detail"
          :args="downloadArgs"
          :showFatherHead="false"
          :dataSource="rawTableData"
          :customColumns="customColumns"
          :spliceIndex="1"
          :showCustomColumns="true"
          :showDownload="true"
          :fixedColumns="fixedColumns"
          :columnDialogStyle="{ width: '800px' }"
          summaryTip="汇总(KA全部数据)"
          @created="handleCustomTableCreated"
          @download="handleCustomTableDownload"
          @change-columns="handleCustomTableColumnsChange"
          @sort-change="handleCustomTableSortChange"
          @filter-x-change="handleCustomTableFilterChange"
          @current-change="handleCustomTableCurrentChange"
          @size-change="handleCustomTableSizeChange"
        >
          <template v-slot:column="{ data: d }">
            <a
              v-if="d.field.key === 'product_name'"
              class="product-report-redirect"
              @click="handleProductNameClick(d.row)"
            >
              {{ d.value }}
            </a>

            <div v-else-if="checkIsHover(d.field.key, d)">
              <div v-if="dimensionBy === 'day'">
                <Tooltip>
                  <div
                    v-if="dimensionBy === 'day'"
                    slot="content"
                  >
                    <div>对比日期：{{ d.value.before_date }}</div>
                    <div>对比日期的值：{{ d.value.before_value }}</div>
                    <div>差值：{{ d.value.diff_value }}</div>
                  </div>
                  <div>
                    <span>{{ d.value.value }}</span>
                    <br>
                    <span :class="`product-report-${checkRate(d.value.rate)}`">
                      ({{ d.value.rate }})
                    </span>
                  </div>
                </Tooltip>
              </div>
              <div v-else>
                <div>
                  <span>{{ d.value.value }}</span>
                </div>
              </div>
            </div>

            <span v-else-if="d.field.key === 'sale_type'">{{ d.value === 1 ? '直投' : (d.value === 2 ? '渠道' : '') }}</span>
            <span v-else-if="d.field.key === 'customer_cate '">{{ d.value === 1 ? 'KA' : '非KA' }}</span>
            <span v-else>{{ d.value }}</span>
          </template>
        </CustomTable>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import {
  Tabs,
  TabPane,
  Select,
  Row,
  Col,
  Option,
  RadioGroup,
  RadioButton,
  Tooltip,
  Button,
} from 'element-ui';

import Title from '@/components/Title';
import DatePicker from '@/components/DatePicker2/Index';
import CustomTable from '@/components/CustomTable2/Index';
import Chart from './components/Chart/Index';

import { getFieldsByList } from '@/config/columns/';
import requestMixin from './mixins/request';
import { fields, customColumns, fixedColumns, fieldWithDiff } from './config';
import { isEmpty } from '@/common/util';
import * as $cache from '@/common/cache';
import dateOptions from './config/date';
import queryGridByContainer from '@/common/js/queryGridByContainer';

const createDefaultDateRange = () => [
  moment().subtract(7, 'day'),
  moment().subtract(1, 'day'),
];

const DEFAULT_QUERY_ORDER = 'day desc';

const createDefaultFilterState = () => ({
  date: createDefaultDateRange(),
  budget_ids: [],
  product_ids: [],
  product_series_ids: [],
  sale_type: undefined,
  account_ids: [],
  sale_ids: [],
  customer_cate: undefined,
});

export default {
  components: {
    Tabs,
    TabPane,
    Select,
    Row,
    Col,
    Option,
    RadioGroup,
    RadioButton,
    Tooltip,
    Button,
    DatePicker,
    Title,
    Chart,
    CustomTable,
  },

  mixins: [requestMixin, queryGridByContainer],

  data() {
    return {
      hourUseable: true,
      date: createDefaultDateRange(),
      lastUpdateTime: '',
      dimension: 'day',
      field: 'cost_total',
      summary: [],
      summaryLoading: true,
      options: getFieldsByList(fields),
      summaryType: 'all',
      chartLoading: true,
      rawChartData: {},
      tableLoading: true,
      page: 1,
      pageSize: 10,
      order: DEFAULT_QUERY_ORDER,
      rawfilters: {},
      fields: [],
      customColumns,
      fixedColumns,
      rawTableData: {},
      dateOptions,
      budgetOptions: [
        { label: '直投', value: 1 },
        { label: '渠道', value: 2 },
      ],
      kaOptions: [
        { value: 1, label: 'KA' },
        { value: 0, label: '非KA' },
      ],
      productSeriesOptions: [],
      salesOptions: [],
      aggregationsOptions: [],
      productsOptions: [],
      ...createDefaultFilterState(),
      dimensionBy: 'day',
      queryExpanded: true,
    };
  },

  computed: {
    dateDiff() {
      const [start, end] = this.date;
      const diff = moment(start).diff(moment(end), 'days');
      return Math.abs(diff) + 1;
    },

    isChartDataEmpty() {
      const { date, list } = this.rawChartData;
      return !(isEmpty(date) && isEmpty(list));
    },

    filters() {
      const arr = [];
      Object.keys(this.rawfilters).forEach((key) => {
        const { type, min, max } = this.rawfilters[key];
        arr.push(`${type},${min},${max}`);
      });
      return arr;
    },

    queryColumnsPerRow() {
      return Math.max(24 / this.queryColSpan, 1);
    },

    collapsedQueryCount() {
      return Math.min(
        Math.max(this.queryColumnsPerRow - 1, 1),
        this.queryFieldKeys.length,
      );
    },

    visibleQueryFieldCount() {
      return this.queryExpanded
        ? this.queryFieldKeys.length
        : this.collapsedQueryCount;
    },

    queryActionSpan() {
      const remainder = this.visibleQueryFieldCount % this.queryColumnsPerRow;
      const remainingColumns =
        remainder === 0
          ? this.queryColumnsPerRow
          : this.queryColumnsPerRow - remainder;

      return remainingColumns * this.queryColSpan;
    },

    queryFieldKeys() {
      return ['date', 'budget_ids', 'product_ids', 'product_series_ids'];
    },

    queryFieldVisibility() {
      const visibility = {};

      this.queryFieldKeys.forEach((key, index) => {
        visibility[key] = index < this.visibleQueryFieldCount;
      });

      return visibility;
    },

    showQueryToggle() {
      return this.queryFieldKeys.length > this.collapsedQueryCount;
    },

    downloadArgs() {
      const params = this.getParams();
      params.order_by = this.order;
      params.dimension = 'common';
      params.fields = [...this.fields]
        .join(',')
        .replace('direct_sale2', 'direct_sale');
      params.filters = this.filters;
      params._login_token = ($cache.localGet($cache.AUTH) || {}).token || '';
      params.sale_type = this.sale_type;
      params.account_ids = this.account_ids;
      params.budget_ids = this.budget_ids ? this.budget_ids.join(',') : '';
      params.sale_ids = this.sale_ids ? this.sale_ids.join(',') : '';
      params.product_ids = this.product_ids ? this.product_ids.join(',') : '';
      params.product_series_ids = this.product_series_ids
        ? this.product_series_ids.join(',')
        : '';
      params.customer_cate = this.customer_cate;
      params.dimensionBy = this.dimensionBy;
      return params;
    },
  },

  watch: {
    date(n) {
      if (n && n.length === 2) {
        const startDate = moment(n[0]).format('YYYY-MM-DD');
        const endDate = moment(n[1]).format('YYYY-MM-DD');
        const flag = this.isDateRangeIncludeToday(startDate, endDate);

        if (this.dimension === 'hour' && !flag) {
          this.dimension = 'day';
          this.dimensionBy = 'day';
        }

        this.hourUseable = flag;
      }
    },
  },

  created() {
    this.queryChartData();
    this.queryProductSeriesList();
    this.queryAggregations('');
    this.queryProducts('');
    this.queryProductSales('');
  },

  methods: {
    isDateRangeIncludeToday(startDate, endDate) {
      const today = new Date();
      const start = new Date(startDate);
      const end = new Date(endDate);

      start.setHours(0, 0, 0, 0);
      end.setHours(23, 59, 59, 999);
      today.setHours(0, 0, 0, 0);

      return today >= start && today <= end;
    },

    handleSearchProducts(val) {
      this.queryProducts(val);
    },

    handleSearchAggregations(val) {
      this.queryAggregations(val);
    },

    handleSearchSeries(val) {
      this.queryProductSeries(val);
    },

    handleSearchSales(val) {
      this.queryProductSales(val);
    },

    toggleQueryExpand() {
      this.queryExpanded = !this.queryExpanded;
    },

    handleReset() {
      Object.assign(this, createDefaultFilterState(), {
        order: DEFAULT_QUERY_ORDER,
        page: 1,
        rawfilters: {},
      });
      this.queryChartData();
      this.queryTableData();
    },

    queryProductSeriesList() {
      this.queryProductSeries();
    },

    handleAggregatedTypeChange(val) {
      this.dimensionBy = val;
    },

    handleDatePickerChange() {
      // keep manual query behavior
    },

    handleSearchData() {
      this.page = 1;
      this.queryChartData();
      this.queryTableData();
    },

    handleDataCardNumClick(data) {
      this.dimension = data.key;
      this.handleTabsClick();
    },

    handleStopDayConfirm() {
      this.dimension = 'stop_product';
      this.queryStopProductSummary();
      this.handleTabsClick();
    },

    handleTabsClick() {
      this.page = 1;
      this.queryChartData();
      this.queryTableData();
    },

    handleFieldSelectChange() {
      this.queryChartData();
    },

    handleSummaryTypeChange() {
      this.queryChartData();
    },

    handleCustomTableDownload() {
      this.download();
    },

    handleCustomTableColumnsChange(fields) {
      this.page = 1;
      this.fields = fields;
      this.queryTableData();
    },

    handleCustomTableCreated(fields) {
      this.page = 1;
      this.fields = fields;
      this.queryTableData();
    },

    handleProductNameClick(data) {
      const url = this.$router.resolve({
        path: '/product-report/exact-product',
        name: 'ProductReportExactProduct',
        query: {
          id: data.product_id,
          name: data.product_name,
          start: this.date[0].format('YYYY-MM-DD'),
          end: this.date[1].format('YYYY-MM-DD'),
        },
      });
      window.open(url.href, '_blank');
    },

    handleCustomTableSortChange(sort) {
      if (sort) {
        this.page = 1;
        this.order = sort;
        this.queryTableData();
      }
    },

    handleCustomTableFilterChange(filter) {
      this.page = 1;
      const { type, min, max } = filter;

      if (min !== undefined && max !== undefined) {
        this.$set(this.rawfilters, type, filter);
      } else {
        this.$delete(this.rawfilters, type);
      }

      this.queryTableData();
    },

    handleCustomTableCurrentChange(current) {
      this.page = current;
      this.queryTableData();
    },

    handleCustomTableSizeChange(size) {
      this.pageSize = size;
      this.queryTableData();
    },

    checkIsHover(key, d) {
      return fieldWithDiff.includes(key) && d.value;
    },

    checkRate(rate) {
      return rate.indexOf('-') !== -1 ? 'bottom' : 'top';
    },

    querySummaryData() {
      // legacy placeholder
    },

    queryChartData() {
      this.chartLoading = true;
      if (this.summaryType === 'all') {
        this.queryMyPerformance();
      } else if (this.summaryType === 'top') {
        this.queryTop20();
      }
    },

    queryTableData() {
      this.tableLoading = true;
      this.queryList();
    },
  },
};
</script>

<style lang="less" scoped>
.product-report {
  font-size: 14px;

  &-lastUpdateTime {
    color: #c0c4cc;
    margin-left: 16px;
  }

  &-summary {
    margin-top: 32px;
  }

  &-card {
    float: left;
    margin: 0 30px 30px 0;

    &:last-child {
      margin-bottom: 0;
    }
  }

  &-chart {
    margin-top: 32px;
  }

  &-tabs {
    margin-top: 32px;

    &-header {
      display: flex;
      justify-content: space-between;
      margin: 10px 0 20px 0;
    }
  }

  &-detail {
    margin-top: 32px;

    &-table {
      margin-top: 32px;
    }
  }

  &-redirect {
    cursor: pointer;
    color: #2f9eff;
  }

  &-top {
    color: @crm-rise-color;
  }

  &-bottom {
    color: @crm-fall-color;
  }
}

.query-item {
  margin-bottom: 20px;
}

.query-item--actions {
  display: flex;
  justify-content: flex-end;
}

.query-buttons {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
}

.query-toggle {
  padding: 0;
}

/deep/ .query-buttons .el-button + .el-button {
  margin-left: 0;
}

/deep/ .el-dialog {
  min-width: 800px;
}
</style>
